import React from 'react';
import './GiftCards.css';
import giftCardImage from '../assets/giftcards/1.JPG';

const GiftCards = () => {
  const handlePurchaseClick = () => {
    window.open('https://www.toasttab.com/sneakers-644-laurel-street/giftcards', '_blank');
  };

  return (
    <div className="gift-cards-container">
      <div className="image-header">
        <img
          src={giftCardImage}
          alt="Highlands Gift Cards"
          className="gift-cards-hero"
        />
        <div className="overlay"></div>
      </div>
      
      <div className="gift-cards-content">
        <h1 className="gift-cards-title">Highlands' Gift Cards</h1>
        
        <div className="gift-cards-description">
          <p>Give the gift of game day excitement and great food at Highlands. Our gift cards are perfect for:</p>
          <ul>
            <li>Sports fans and game day gatherings</li>
            <li>Birthday celebrations with friends</li>
            <li>Team celebrations and victories</li>
            <li>Thank you gestures for the sports lovers in your life</li>
            <li>Casual nights out with great food and drinks</li>
          </ul>
          <p>Available in any denomination, our digital gift cards can be purchased online and delivered instantly via email. Score big points with a Highlands gift card today!</p>
        </div>

        <button onClick={handlePurchaseClick} className="purchase-button">
          Purchase Gift Cards
        </button>
      </div>
    </div>
  );
};

export default GiftCards; 